export default __webpack_public_path__ + "../staticImages/browser-firefox.png";